import React from "react";
import { AssetForm, AssetFormProps } from "./asset-form";

export interface AssetFormModalProps extends AssetFormProps {
  isOpen: boolean;
  onClose: () => void;
}

export function AssetFormModal({
  isOpen,
  onClose,
  ...formProps
}: AssetFormModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex min-h-screen items-center justify-center p-4">
        {/* Backdrop */}
        <div
          className="fixed inset-0 bg-black bg-opacity-50 transition-opacity"
          onClick={onClose}
        />

        {/* Modal */}
        <div
          className="relative w-full max-w-4xl bg-white rounded-lg shadow-xl"
          data-testid="asset-form-modal"
        >
          {/* Header */}
          <div className="flex items-center justify-between p-6 border-b border-gray-200">
            <h2
              className="text-xl font-semibold text-gray-900"
              data-testid="modal-title"
            >
              {formProps.title ||
                (formProps.isEditing ? "Edit Asset" : "Create Asset")}
            </h2>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600 transition-colors"
              data-testid="modal-close-button"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>

          {/* Content */}
          <div className="p-6 max-h-[calc(100vh-200px)] overflow-y-auto">
            <AssetForm
              {...formProps}
              onCancel={onClose}
              title={undefined} // Don't show title in form since it's in modal header
            />
          </div>
        </div>
      </div>
    </div>
  );
}
